import { basename } from '@/lib/desktop-paths';

export const PERSONAL_WORKSPACE_NAME = 'Personal workspace';

/** Returns the user-facing workspace name without exposing the managed directory name. */
export function desktopWorkspaceName(
  workspaceRoot: string,
  personalWorkspaceRoot: string | null,
): string {
  return workspaceRoot === personalWorkspaceRoot
    ? PERSONAL_WORKSPACE_NAME
    : basename(workspaceRoot);
}
